import { motion } from "framer-motion";
import { Award, MapPin, Calendar, HeartHandshake } from "lucide-react";

const PILLARS = [
  {
    icon: Award,
    title: "Equipa experiente e dedicada",
    desc: "Profissionais com formação contínua e amor genuíno por animais.",
  },
  {
    icon: MapPin,
    title: "Duas clínicas na Madeira",
    desc: "Ribeira Brava e Calheta — perto de si, sempre que precisar.",
  },
  {
    icon: Calendar,
    title: "Marcação online 24/7",
    desc: "Escolha o horário que melhor lhe convier, sem chamadas nem esperas.",
  },
  {
    icon: HeartHandshake,
    title: "Acompanhamento próximo",
    desc: "Seguimos cada caso com proximidade e clareza nas explicações.",
  },
];

export const Pillars = () => {
  return (
    <section
      data-testid="pillars-section"
      className="py-20 md:py-28 bg-white border-y border-[#1E5F6E]/8"
    >
      <div className="container-app">
        <div className="max-w-2xl mb-14">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#88A096] mb-3">
            Porquê escolher-nos
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1A1A] tracking-tight">
            Quatro razões para nos <span className="text-[#1E5F6E]">confiar</span> o seu companheiro.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.55, delay: i * 0.08 }}
                data-testid="pillar-item"
                className="relative"
              >
                <div className="flex items-start gap-4">
                  <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-gradient-to-br from-[#1E5F6E] to-[#0F3A44] text-white shadow-[0_8px_20px_-8px_rgba(15,58,68,0.5)]">
                    <Icon className="h-5 w-5" strokeWidth={2.1} />
                  </span>
                  <div className="text-xs font-bold tracking-widest text-[#88A096] mt-3">
                    0{i + 1}
                  </div>
                </div>
                <h3 className="mt-5 font-display text-lg md:text-xl font-bold text-[#1A1A1A] leading-snug">
                  {p.title}
                </h3>
                <p className="mt-2 text-[15px] text-[#5A5A5A] leading-relaxed">
                  {p.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Pillars;
